export enum UiTheme {
  GK = 'greenkub',
  GEKA = 'geka',
}
